import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import {Link} from "react-router-dom";
import GameComponent from "game/app/components/game/game-component";
import {push} from "react-router-redux";
import assets from "game/app/assets";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";
import VideoBtn from "game/app/components/video-btn";

class MainMenu extends GameComponent {

    startGame = () => {
        this.props.sendInput(this.getInstanceId(), { type: 'start' }).then(() => {
            this.props.push(`/game/${this.getInstanceId()}/round-1`);
        });
    };

    render() {
        let instanceId = this.props.match.params.id;
        let index = this.getNodeIndex(this.getCurrentNodeType());

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1 className='page-title separate-bottom'>Vítejte v soutěži Rozpočti si to!</h1>

                        <div className='separate-bottom text-center'>
                            <VideoBtn videoId='_l_4RgfShzs'><FontAwesomeIcon icon={['fas', 'play']} /> Podívejte se na pravidla soutěže</VideoBtn>
                        </div>

                        <h2 className='page-title-minor separate-bottom'>Čekají na vás 3 kola</h2>

                        <div className='row text-center aligned-lg separate-bottom'>
                            <div className='col-lg-4'>
                                <div className='card aligned-card'>
                                    <div className='card-body'>
                                        <img src={assets.kolo_1} className='img-fluid'/>
                                        <h3>Profil</h3>
                                        <p className='fill'>V prvním kole si určíte, jak bude vypadat vaše rodina či domácnost, kde budete bydlet, vyřešíte si dopravu či jídlo.</p>
                                        { index < this.getNodeIndex("Nodes::Round01Node") && <button className='btn btn-primary' onClick={this.startGame}>Vstoupit</button> }
                                        { index === this.getNodeIndex("Nodes::Round01Node") && <Link className='btn btn-primary' to={`/game/${instanceId}/round-1`}>Vstoupit</Link> }
                                        { index > this.getNodeIndex("Nodes::Round01Node") && <Link className='btn btn-outline-primary' to={`/game/${instanceId}/round-1`}>Vstoupit</Link> }
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4'>
                                <div className='card aligned-card'>
                                    <div className='card-body'>
                                        <img src={assets.kolo_2} className='img-fluid'/>
                                        <h3>Výdaje</h3>
                                        <p className='fill'>V druhém kole se podíváme na další výdaje, se kterými je potřeba počítat. A také budete čelit neplánovaným životním situacím, které se vám přihodily.</p>
                                        { index < this.getNodeIndex("Nodes::Round02Node") && <span className='btn btn-secondary disabled'>Vstoupit</span> }
                                        { index === this.getNodeIndex("Nodes::Round02Node") && <Link className='btn btn-primary' to={`/game/${instanceId}/round-2`}>Vstoupit</Link> }
                                        { index > this.getNodeIndex("Nodes::Round02Node") && <Link className='btn btn-outline-primary' to={`/game/${instanceId}/round-2`}>Vstoupit</Link> }
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4'>
                                <div className='card aligned-card'>
                                    <div className='card-body'>
                                        <img src={assets.kolo_3} className='img-fluid'/>
                                        <h3>Vánoce a rezervy</h3>
                                        <p className='fill'>Poslední kolo je věnované Vánočním svátkům, možnosti přivýdělku a spoření a investicím.</p>
                                        { index < this.getNodeIndex("Nodes::Round03Node") && <span className='btn btn-secondary disabled'>Vstoupit</span> }
                                        { index === this.getNodeIndex("Nodes::Round03Node") && <Link className='btn btn-primary' to={`/game/${instanceId}/round-3`}>Vstoupit</Link> }
                                        { index > this.getNodeIndex("Nodes::Round03Node") && <Link className='btn btn-outline-primary' to={`/game/${instanceId}/round-3`}>Vstoupit</Link> }
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='card text-center'>
                            <div className='card-body'>
                                <h2>Bonusové úkoly</h2>
                                <p>Popusťte uzdu své kreativitě. Bonusové úkoly jsou tu od toho.</p>
                                <Link className='btn btn-primary' to={`/game/${instanceId}/bonus-tasks`}>Bonusové úkoly</Link>
                            </div>
                        </div>

                        <div className='card text-center'>
                            <div className='card-body'>
                                <h2>Vyhodnocení</h2>
                                <p>Zajímá vás, jak jste si vedli? Po skončení hry se tady můžete podívat na vyhodnocení.</p>
                                { index < this.getNodeIndex("Nodes::FinalNode") && <span className='btn btn-secondary disabled' to={`/game/${instanceId}/final`}>Zobrazit vyhodnocení</span> }
                                { index === this.getNodeIndex("Nodes::FinalNode") && <Link className='btn btn-primary' to={`/game/${instanceId}/final`}>Zobrazit vyhodnocení</Link> }
                                { index > this.getNodeIndex("Nodes::FinalNode") && <Link className='btn btn-secondary' to={`/game/${instanceId}/final`}>Zobrazit vyhodnocení</Link> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        push: push
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(MainMenu);
